import "core-js/modules/es.function.name";
import _objectSpread from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue';
import { showErrors, showNotification } from '@/utils/snack';
import { SnackType } from '@/interfaces/snack';
import AppTextField from '@/components/AppTextField.vue';
import AppFormItem from '@/components/AppFormItem.vue';
import AppListSelector from '@/components/AppListSelector.vue';
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue';
import { updateSchool, createSchool } from './gql';
import { findSchool } from '../SchoolList/gql';
import AppDialog from '@/components/AppDialog.vue';
Component.registerHooks(['beforeRouteLeave']);

var Editgoods = /*#__PURE__*/function (_Vue) {
  _inherits(Editgoods, _Vue);

  var _super = _createSuper(Editgoods);

  function Editgoods() {
    var _this;

    _classCallCheck(this, Editgoods);

    _this = _super.apply(this, arguments);
    _this.breadcrumbs = [{
      text: '学校管理'
    }, {
      text: '学校',
      to: {
        name: 'SchoolList'
      }
    }];
    _this.items = ['基本信息', '经销商'];
    _this.school = null;
    _this.schoolInput = {
      area: null,
      name: '',
      status: null
    };
    _this.originInput = '';
    _this.isEdit = false;
    _this.activeTab = 0;
    _this.schoolId = '';
    _this.editSchoolName = '';
    _this.hint = {
      text: '',
      color: ''
    };
    _this.disabledActions = true;
    _this.isLeave = false;
    _this.saveDialog = {
      title: '是否保存',
      show: false,
      text: ''
    };
    return _this;
  }

  _createClass(Editgoods, [{
    key: "onAreaChange",
    value: function onAreaChange(val) {
      if (!val) {
        this.hint.text = '请选择地区';
        this.hint.color = 'red';
      } else {
        this.hint = {
          text: '',
          color: ''
        };
      }
    }
  }, {
    key: "schoolInputChange",
    value: function schoolInputChange(val) {
      if (JSON.stringify(val) !== this.originInput) {
        this.disabledActions = false;
      } else {
        this.disabledActions = true;
      }
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var type;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                type = sessionStorage.getItem('type');

                if (!type) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return this.initData(type);

              case 4:
                _context.next = 9;
                break;

              case 6:
                sessionStorage.setItem('type', this.$route.params.type);
                _context.next = 9;
                return this.initData(this.$route.params.type);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "initData",
    value: function () {
      var _initData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(type) {
        var id;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(type === 'new')) {
                  _context2.next = 5;
                  break;
                }

                this.isEdit = false;
                this.breadcrumbs.push({
                  text: '添加学校'
                });
                _context2.next = 10;
                break;

              case 5:
                this.isEdit = true;
                id = this.$route.params.id;
                this.schoolId = id;
                _context2.next = 10;
                return this.getSchoolById();

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initData(_x) {
        return _initData.apply(this, arguments);
      }

      return initData;
    }()
  }, {
    key: "getSchoolById",
    value: function () {
      var _getSchoolById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var result, _result$data$findScho, area, name, typedError;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$apollo.query({
                  query: findSchool,
                  variables: {
                    schoolId: +this.schoolId
                  }
                });

              case 3:
                result = _context3.sent;

                if (result) {
                  _result$data$findScho = result.data.findSchool, area = _result$data$findScho.area, name = _result$data$findScho.name;
                  this.schoolInput = {
                    name: name,
                    area: area
                  };
                  this.originInput = JSON.stringify(this.schoolInput);
                  this.breadcrumbs = [{
                    text: '学校管理'
                  }, {
                    text: '学校',
                    to: {
                      name: 'SchoolList'
                    }
                  }];
                  this.breadcrumbs.push({
                    text: "".concat(name)
                  });
                }

                _context3.next = 11;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function getSchoolById() {
        return _getSchoolById.apply(this, arguments);
      }

      return getSchoolById;
    }()
  }, {
    key: "clearForm",
    value: function clearForm() {
      this.schoolInput = {
        area: null,
        name: '',
        dealerArea: null
      };
    }
  }, {
    key: "submitBasic",
    value: function () {
      var _submitBasic = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.schoolInput.area) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return this.editSchoolRequest();

              case 3:
                _context4.next = 6;
                break;

              case 5:
                showNotification({
                  msg: '请选择地区！',
                  type: SnackType.Error
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function submitBasic() {
        return _submitBasic.apply(this, arguments);
      }

      return submitBasic;
    }()
  }, {
    key: "editSchoolRequest",
    value: function () {
      var _editSchoolRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this$schoolInput, area, name, request, msg, input, variables, schoolId, result, typedError;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.validateForm('form')) {
                  _context5.next = 18;
                  break;
                }

                _this$schoolInput = this.schoolInput, area = _this$schoolInput.area, name = _this$schoolInput.name;
                request = !this.isEdit ? createSchool : updateSchool;
                msg = !this.isEdit ? '添加' : '编辑';
                input = {
                  areaId: area.id,
                  name: name,
                  status: 'PENDING'
                };
                variables = {};

                if (this.isEdit) {
                  schoolId = +this.schoolId;
                  variables = {
                    input: input,
                    schoolId: schoolId
                  };
                } else {
                  variables = {
                    input: input
                  };
                }

                _context5.prev = 7;
                _context5.next = 10;
                return this.$apollo.mutate({
                  mutation: request,
                  variables: _objectSpread({}, variables)
                });

              case 10:
                result = _context5.sent;

                if (result) {
                  showNotification({
                    msg: "".concat(msg, "\u6210\u529F\uFF01"),
                    type: SnackType.Success
                  });
                  this.isEdit = true;
                  sessionStorage.setItem('type', 'edit');
                  this.disabledActions = true;
                  this.$router.go(-1);
                } else {
                  showNotification({
                    msg: "".concat(msg, "\u5931\u8D25\uFF01"),
                    type: SnackType.Error
                  });
                }

                _context5.next = 18;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](7);
                typedError = _context5.t0;
                showErrors(typedError.graphQLErrors);

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[7, 14]]);
      }));

      function editSchoolRequest() {
        return _editSchoolRequest.apply(this, arguments);
      }

      return editSchoolRequest;
    }()
  }, {
    key: "resetValidation",
    value: function resetValidation(form) {
      this.$refs[form].resetValidation();
    }
  }, {
    key: "validateForm",
    value: function validateForm(form) {
      return this.$refs[form].validate();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (!this.disabledActions) {
        this.saveDialog.show = true;
      }

      sessionStorage.removeItem('type');
    }
  }, {
    key: "beforeRouteLeave",
    value: function () {
      var _beforeRouteLeave = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(to, from, next) {
        var res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!this.disabledActions) {
                  res = confirm('页面修改尚未保存，是否确定要离开？');
                  next(res);
                } else {
                  next();
                }

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function beforeRouteLeave(_x2, _x3, _x4) {
        return _beforeRouteLeave.apply(this, arguments);
      }

      return beforeRouteLeave;
    }()
  }]);

  return Editgoods;
}(Vue);

__decorate([Watch('schoolInput.area', {
  deep: true,
  immediate: true
})], Editgoods.prototype, "onAreaChange", null);

__decorate([Watch('schoolInput', {
  deep: true
})], Editgoods.prototype, "schoolInputChange", null);

Editgoods = __decorate([Component({
  components: {
    AppBreadcrumbs: AppBreadcrumbs,
    AppTextField: AppTextField,
    AppFormItem: AppFormItem,
    AppListSelector: AppListSelector,
    AppSimpleDistrictSelector: AppSimpleDistrictSelector,
    AppDialog: AppDialog
  }
})], Editgoods);
export default Editgoods;